import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ViewModal from "components/modal/ViewVendorEnquiryModal";
import Tooltip from "components/tooltip/Tooltip";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";
import { FiEye } from "react-icons/fi";
import RemarkModal from "components/modal/RemarkModal";
// internal imports

const VendorRequestTable = ({ vendor, perpage, currentPage }) => {
  const { title, serviceId, serviceBlock, handleView } = useToggleDrawer();
  return (
    <>
      <RemarkModal
        id_data={serviceId}
        block_data={serviceBlock}
        title_data={title}
      ></RemarkModal>
      <DeleteModal id={serviceId} title={title} />
      <ViewModal id={serviceId} title={title} data={vendor} />

      <MainDrawer>{/* <VendorDrawer id={serviceId} /> */}</MainDrawer>

      <TableBody>
        {vendor?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="text-center text-sm">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>
            <TableCell className="text-center text-sm">
              {data.company_name}
            </TableCell>
            <TableCell className="text-center text-sm">
              {data.full_name}
            </TableCell>
            <TableCell className="text-center text-sm">
              {data.city_name}
            </TableCell>
            <TableCell className="text-center text-sm">
              {data?.added_date
                ? new Date(data.added_date).toLocaleDateString("en-GB")
                : "Null"}
            </TableCell>

            <TableCell>
              <div className="flex justify-center">
                <button
                  onClick={() => handleView(data.id, "Vendor Details")}
                  className="p-2 cursor-pointer text-gray-400 hover:text-green-600 focus:outline-none"
                >
                  <Tooltip
                    id={data.id}
                    Icon={FiEye}
                    title="ViewOrder"
                    bgColor="#34D399"
                  />
                </button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default VendorRequestTable;
